import { render, staticRenderFns } from "./QuestionnaireDiaLog.vue?vue&type=template&id=2ab61f99&scoped=true&"
import script from "./QuestionnaireDiaLog.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireDiaLog.vue?vue&type=script&lang=js&"
import style0 from "./QuestionnaireDiaLog.vue?vue&type=style&index=0&id=2ab61f99&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab61f99",
  null
  
)

export default component.exports